import { MODEL_INTIAL_OBJECT } from '@/config/settings';
import { createContext } from 'react';

const initialSettingContext: SettingContextStore = {
  modelProvider: '',
  modelName: '',
  personality: '',
  creativity: '',
  role: '',
  domainExpertise: '',
  writingStyle: '',
  outputLanguage: '',
  showSourceList: true,
  selectedModel: MODEL_INTIAL_OBJECT,
  allModels: [],
  selectedLanguage: '',
  defaultLanguage: '',
  defaultModel: MODEL_INTIAL_OBJECT,
  allLanguages: [],
  languageUsedForResponse: '',
  modelUsedForResponse: MODEL_INTIAL_OBJECT,
  totalImageQuota: 0,
  availableImageQuota: 0,
  settingsIconRef: null,
  defaultTheme: 'Light',
  allThemes: ['Light', 'Dark'],
  setModelProvider: () => {},
  setModelName: () => {},
  setPersonality: () => {},
  setCreativity: () => {},
  setRole: () => {},
  setDomainExpertise: () => {},
  setWritingStyle: () => {},
  setOutputLanguage: () => {},
  setShowSourceList: () => {},
  setSelectedModel: () => {},
  setAllModels: () => {},
  setSelectedLanguage: () => {},
  setDefaultLanguage: () => {},
  setDefaultModel: () => {},
  setAllLanguages: () => {},
  setTotalImageQuota: () => {},
  setAvailableImageQuota: () => {},
  setDefaultTheme: () => {},
  setAllThemes: () => {},
};

export const SettingContext = createContext<SettingContextStore>(initialSettingContext);
